import { message } from "antd";
import {
  CONTACT_LIST_REQUEST,
  CONTACT_LIST_SUCCESS,
  CONTACT_LIST_FAIL,
  CONTACT_DELETE_REQUEST,
  CONTACT_DELETE_SUCCESS,
  CONTACT_DELETE_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/contactConstants";
import axios from "../../../axiosInstance";

// Get All Contacts
export const listContacts = () => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_LIST_REQUEST });

    const { data } = await axios.get(`/api/v1/contact/admin-get-contact`);

    if (data.success === true) {
      dispatch({ type: CONTACT_LIST_SUCCESS, payload: data.contactInfo });
    } else {
      dispatch({ type: CONTACT_LIST_FAIL, payload: data.message });
      message.error(data.message);
    }
  } catch (error) {
    dispatch({
      type: CONTACT_LIST_FAIL,
      payload: error.response?.data?.message || "Failed to fetch contacts",
    });
    message.error(error.response?.data?.message || "Failed to fetch contacts");
  }
};

// Delete Contact
export const deleteContact = (id) => async (dispatch) => {    
  try {
    dispatch({ type: CONTACT_DELETE_REQUEST });

    const { data } = await axios.delete(`/api/v1/contact/admin-delete-contact`, {
      data: { id },
    });

    if (data.success === true) {
      dispatch({ type: CONTACT_DELETE_SUCCESS, payload: id });
      message.success(data.message);
    } else {
      dispatch({ type: CONTACT_DELETE_FAIL, payload: data.message });
      message.error(data.message);
    }
  } catch (error) {
    dispatch({
      type: CONTACT_DELETE_FAIL,
      payload: error.response?.data?.message || "Failed to delete contact",
    });
    message.error(error.response?.data?.message || "Failed to delete contact");
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
